import {HubConnectionBuilder} from '@microsoft/signalr';

const ConnectionService = {
  getHubConnection: function (origin, path, autoReconnect) {
    let builder = new HubConnectionBuilder()
      .withUrl(origin + path);

    if (autoReconnect == true) {
      builder = builder.withAutomaticReconnect({
        nextRetryDelayInMilliseconds: function () {
          return 2000;
        }
      });
    }

    return builder.build();
  },
  getConnection: function (path) {
    return this.getHubConnection(this.getOrigin(), path, false);
  },
  getAutoReconnectConnection: function (path) {
    return this.getHubConnection(this.getOrigin(), path, true);
  },
  getPort: function () {
    let port = parseInt(window.location.port);
    if (isNaN(port)) {
      port = window.location.protocol == "https:" ? 443 : 80;
    }
    else if (port == 8080) {
      port = window.location.protocol == "https:" ? 5001 : 5000;
    }
    return port;
  },
  getUrl(path) {
    return this.getOrigin() + path;
  },
  getOrigin() {
    return window.location.protocol + "//" + window.location.hostname + ":" + this.getPort();
  }
};

export {ConnectionService}
